import wx from "weixin-js-sdk"; // 微信sdk依赖
import axios from "axios";
// 引用全局
/* eslint-disable */
const jsApiList = [
  "updateTimelineShareData",
  "updateAppMessageShareData",
  "onMenuShareQQ",
  "onMenuShareWeibo"
];

// 要用到微信API
export function getJSSDK(url, title) {
  // console.log(dataForWeixin);
  // 调用后台接口换取参数
  axios
    .get("/weiXin/signature", {
      params: {
        url
      }
    })
    .then(res => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: "wx0b991edce6ce490c", // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名
        jsApiList: [
          "updateTimelineShareData",
          "updateAppMessageShareData",
          "onMenuShareQQ",
          "onMenuShareWeibo"
        ] // 必填，需要使用的JS接口列表
      });
      console.log(document.title);
      wx.ready(() => {
        let dataShare = {
          title: "云上世界", // 分享标题
          desc: document.title, // 分享内容
          link: url, // 分享链接
          imgUrl:
            "https://img.yunshangzg.com/commodity/20211206/9CGRCXSDDFFFER未标题_全景图25.jpg?x-oss-process=image/resize,h_300" // 分享内容显示的图片(图片必须是正方形的链接)
        };
        wx.updateAppMessageShareData(dataShare);
        wx.updateTimelineShareData(dataShare);
        wx.onMenuShareQQ(dataShare);
        wx.onMenuShareWeibo(dataShare);
        // wx.onMenuShareAppMessage({
        //   title: dataForWeixin.title,
        //   desc: dataForWeixin.desc,
        //   link: dataForWeixin.linkurl,
        //   imgUrl: dataForWeixin.img,
        //   trigger: function trigger(res) {},
        //   success: function success(res) {
        //     alert('成功');
        //   },
        //   cancel: function cancel(res) {
        //     alert('已取消');
        //   },
        //   fail: function fail(res) {
        //     alert(JSON.stringify(res), 123456);
        //   },
        // });
        // // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        // wx.onMenuShareTimeline({
        //   title: dataForWeixin.title,
        //   link: dataForWeixin.linkurl,
        //   imgUrl: dataForWeixin.img,
        //   trigger: function trigger(res) {
        //     // alert('用户点击分享到朋友圈');
        //   },
        //   success: function success(res) {
        //     alert('成功');
        //   },
        //   cancel: function cancel(res) {
        //     alert('取消');
        //   },
        //   fail: function fail(res) {
        //     alert(JSON.stringify(res));
        //   },
        // });
        // // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        // wx.onMenuShareQQ({
        //   title: dataForWeixin.title,
        //   desc: dataForWeixin.desc,
        //   link: dataForWeixin.linkurl,
        //   imgUrl: dataForWeixin.img,
        //   trigger: function trigger(res) {
        //     // alert('用户点击分享到QQ');
        //   },
        //   complete: function complete(res) {
        //     alert(JSON.stringify(res));
        //   },
        //   success: function success(res) {
        //     // alert('已分享');
        //   },
        //   cancel: function cancel(res) {
        //     // alert('已取消');
        //   },
        //   fail: function fail(res) {
        //     // alert(JSON.stringify(res));
        //   },
        // });
        // // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        // wx.onMenuShareWeibo({
        //   title: dataForWeixin.title,
        //   desc: dataForWeixin.desc,
        //   link: dataForWeixin.linkurl,
        //   imgUrl: dataForWeixin.img,
        //   trigger: function trigger(res) {
        //     // alert('用户点击分享到微博');
        //   },
        //   complete: function complete(res) {
        //     // alert(JSON.stringify(res));
        //   },
        //   success: function success(res) {
        //     // alert('已分享');
        //   },
        //   cancel: function cancel(res) {
        //     // alert('已取消');
        //   },
        //   fail: function fail(res) {
        //     // alert(JSON.stringify(res));
        //     console.log(JSON.stringify(res));
        //   },
        // });
      });
      wx.error(res => {
        console.log(`${JSON.stringify(res)}微信验证失败`, 456);
        // alert(JSON.stringify(res)+"微信验证失败");
      });
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/share/wxShare.js
// module id = null
// module chunks = 